export const iconFamilyBaseTokens = {
  "icon.family.material": "Material Symbols Outlined"
} as const;

export type IconFamilyToken = keyof typeof iconFamilyBaseTokens;

export const getIconFamilyTokenValue = (token: IconFamilyToken): string => iconFamilyBaseTokens[token];

export const iconFillBaseTokens = {
  "icon.fill.outlined": 0,
  "icon.fill.filled": 1
} as const;

export type IconFillToken = keyof typeof iconFillBaseTokens;

export const getIconFillTokenValue = (token: IconFillToken): number => iconFillBaseTokens[token];

export const iconWeightBaseTokens = {
  "icon.weight.regular": 400
} as const;

export type IconWeightToken = keyof typeof iconWeightBaseTokens;

export const getIconWeightTokenValue = (token: IconWeightToken): number => iconWeightBaseTokens[token];

export const iconGradeBaseTokens = {
  "icon.grade.default": 0
} as const;

export type IconGradeToken = keyof typeof iconGradeBaseTokens;

export const getIconGradeTokenValue = (token: IconGradeToken): number => iconGradeBaseTokens[token];

export const iconSizeBaseTokens = {
  "icon.size.xs": "16px",
  "icon.size.sm": "20px",
  "icon.size.md": "24px",
  "icon.size.lg": "32px",
  "icon.size.xl": "40px"
} as const;

export type IconSizeToken = keyof typeof iconSizeBaseTokens;

export const getIconSizeTokenValue = (token: IconSizeToken): string => iconSizeBaseTokens[token];

export const iconOpacityBaseTokens = {
  "icon.opacity.disabled": 0.4
} as const;

export type IconOpacityToken = keyof typeof iconOpacityBaseTokens;

export const getIconOpacityTokenValue = (token: IconOpacityToken): number => iconOpacityBaseTokens[token];
